<template>
    <div class="account-index-page" v-if="userInfo">
        <el-card class="basic-card">
            <div slot="header" class="clearfix">{{$t('account.Index_page_tips_1')}}</div>
            <div class="basic-info-form">
                <div class="form-item">
                    <div class="label">{{$t('account.Index_page_tips_2')}}</div>
                    <div class="filed margin-l-20">
                        <el-avatar :size="64" :src="userInfo.avatar" icon="el-icon-user" class="fonts-36"></el-avatar>
                    </div>
                </div>
                <div class="form-item">
                    <div class="label">{{$t('account.Index_page_tips_3')}}</div>
                    <div class="filed margin-l-20">
                        <span v-if="userInfo.nickname">{{userInfo.nickname}}</span>
                        <span class="color-666666" v-else>{{$t('account.Index_page_tips_4')}}</span>
                        <span class="margin-l-15 cursor-pointer" @click="editNickNameEvent">
                            <svg-icon name="ib-edit-o"></svg-icon>
                        </span>
                    </div>
                </div>
            </div>
        </el-card>
        <el-card class="basic-card margin-t-20">
            <div slot="header" class="clearfix">{{$t('account.Index_page_tips_5')}}</div>
            <div>
                <div class="flex flex-align-center border-default radius-6 bg-F8F8F8" style="padding: 25px 30px;">
                    <div class="color-success fonts-20 margin-r-25" v-if="userInfo.phone">
                        <svg-icon name="ib-check-o"></svg-icon>
                    </div>
                    <div class="color-error fonts-24 margin-r-25" v-else>
                        <svg-icon name="ib-warning-o"></svg-icon>
                    </div>
                    <div class="flex-1">
                        <div class="">{{$t('account.Index_page_tips_6')}}</div>
                        <div class="color-7C7C7C margin-t-10">{{userInfo.phone || $t('account.Index_page_tips_7')}}</div>
                    </div>
                    <div class="cursor-pointer fonts-15" @click="changeBindEvent('phone')">{{userInfo.phone? $t('account.Index_page_tips_8') : $t('account.Index_page_tips_9')}}</div>
                </div>
                <div class="flex flex-align-center border-default radius-6 bg-F8F8F8 margin-t-15" style="padding: 25px 30px;">
                    <div class="color-success fonts-20 margin-r-25" v-if="userInfo.openId">
                        <svg-icon name="ib-check-o"></svg-icon>
                    </div>
                    <div class="color-error fonts-24 margin-r-25" v-else>
                        <svg-icon name="ib-warning-o"></svg-icon>
                    </div>
                    <div class="flex-1">
                        <div class="">{{$t('account.Index_page_tips_11')}}</div>
                        <div class="color-7C7C7C margin-t-10">{{userInfo.openId ? $t('account.Index_page_tips_10') : $t('account.Index_page_tips_7')}}</div>
                    </div>
                    <template v-if="userInfo.openId">
                        <div class="cursor-pointer fonts-15 color-error" @click="changeBindEvent('wechat')">{{$t('account.Index_page_tips_12')}}</div>
                    </template>
                    <template v-else>
                        <div class="cursor-pointer fonts-15" @click="changeBindEvent('wechat')">{{$t('account.Index_page_tips_9')}}</div>
                    </template>
                </div>
                
                <div class="flex flex-align-center border-default radius-6 bg-F8F8F8 margin-t-15" style="padding: 25px 30px;">
                    <div class="color-success fonts-20 margin-r-25" v-if="userInfo.email">
                        <svg-icon name="ib-check-o"></svg-icon>
                    </div>
                    <div class="color-error fonts-24 margin-r-25" v-else>
                        <svg-icon name="ib-warning-o"></svg-icon>
                    </div>
                    <div class="flex-1">
                        <div class="">{{$t('account.Index_page_tips_13')}}</div>
                        <div class="color-7C7C7C margin-t-10">{{userInfo.email || $t('account.Index_page_tips_7')}}</div>
                    </div>
                    <div class="cursor-pointer fonts-15" @click="changeBindEvent('email')">{{userInfo.email ? $t('account.Index_page_tips_8') : $t('account.Index_page_tips_9')}}</div>
                </div>
                <div class="flex flex-align-center border-default radius-6 bg-F8F8F8 margin-t-15" style="padding: 25px 30px;">
                    <div class="color-success fonts-20 margin-r-25">
                        <svg-icon name="ib-check-o"></svg-icon>
                    </div>
                    <div class="flex-1">
                        <div class="">{{$t('account.Index_page_tips_14')}}</div>
                        <div class="color-7C7C7C margin-t-10">{{$t('account.Index_page_tips_15')}}</div>
                    </div>
                    <div class="cursor-pointer fonts-15" @click="changeBindEvent('password')">{{$t('account.Index_page_tips_8')}}</div>
                </div>
                
            </div>
        </el-card>
        <alert-dialog ref="alertDialogDom" 
            :message="$t('account.Index_page_alertDialog_message')" 
            type="confirm" 
            :buttonName="$t('account.Index_page_alertDialog_buttonName')"
            buttonType="danger"
            @confirmEvent="unbindWechatConfirmEvent"></alert-dialog>
        <change-phone ref="changePhoneDialog"></change-phone>
        <change-email ref="changeEmailDialog"></change-email>
        <change-password ref="changePasswordDialog"></change-password>
        <change-nickname ref="ChangeNicknameDialog"></change-nickname>
    </div>
</template>
<script>
import { mapState } from "vuex";
import config from '@/utils/config';
import { userApi } from '@/utils/api';
import AlertDialog from '@/components/AlertDialog';
import PageTitle from '@/components/PageTitle';
import ChangePassword from './components/ChangePassword';
import ChangePhone from './components/ChangePhone';
import ChangeEmail from './components/ChangeEmail';
import ChangeNickname from './components/ChangeNickname';
export default {
    components: { AlertDialog, PageTitle, ChangePassword, ChangePhone, ChangeEmail, ChangeNickname, },
    data(){
        return{
            nickname: '',
            loading: false,
            alert: {
                
            }
        }
    },
    computed: {
		...mapState({
			userInfo: state => state.user.userData,
		}),
	},
    methods:{
        beforeAvatarUpload(file){

        },
        handleAvatarSuccess(response, file, fileList){
            let data = response.data;
            this.imageUrl = data.url;
            //TODO 更新前端存储用户信息 

        },
        editNickNameEvent(){
             this.$refs['ChangeNicknameDialog'].setShow(true);
        },
        changeBindEvent(key){
            switch (key){
                case 'phone':
                    this.$refs['changePhoneDialog'].setShow(true);
                    break;
                case 'email':
                    this.$refs['changeEmailDialog'].setShow(true);
                    break;
                case 'password':
                    this.$refs['changePasswordDialog'].setShow(true);
                    break;
                case 'wechat':
                    if(this.userInfo.openId){
                        this.$refs.alertDialogDom.setShow(true);
                    }else{
                        if(this.userInfo.phone){
                            this.$store.dispatch('user/setBindWechatVisible', true);
                        }else{
                            this.$message.error(this.$t('account.Index_page_method_changeBindEvent_message_1'));
                        }
                    }
                    
                    break;
            }
        },
        unbindWechatConfirmEvent(){
            let url = userApi.unbindWechat;
            this.$ajax.get(url).then(res => {
                if (res.status === 200){
                    this.$router.go(0);
                    this.$message.success(this.$t('account.Index_page_method_unbindWechatConfirmEvent_message_1'));
                }
            })
        },
    },
    mounted() {
        this.nickname = this.userInfo.nickname;
    }
}
</script>
<style lang="scss" scoped>
.account-index-page{
    .avatar{
        border-radius: 50%;
        width: 64px;
        height: 64px;
    }
    .basic-card{
        box-shadow: initial;
        ::v-deep .el-form-item__label{
            line-height: 1;
        }
    }
    .basic-info-form{
        .form-item{
            display: flex;
            align-items: center;
            margin-bottom: 20px;
            .label{
                font-size: 15px;
                line-height: 24px;
                padding-right: 20px;
            }
            .field{
                font-size: 15px;
                line-height: 24px;
            }
        }
    }
}
</style>
